import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-expanded-payment-history-detail-dialog',
    template: require('./expandedPaymentHistoryDetail.html')
})
export class ExpandedPaymentHistoryDetailDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<ExpandedPaymentHistoryDetailDialog>) public dialogRef: MatDialogRef<ExpandedPaymentHistoryDetailDialog>) {
    }

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }

}
